var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.giftModal,_vm._g(_vm._b({attrs:{"modal":_setup.modal},on:{"close":_setup.onClose}},'giftModal',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }